export default __webpack_public_path__ + "static/campfire-c1691646d87b865d187fad3a48bc732e.svg";